import {CreateEntity, Entity, EntityModel, parseDate} from './entity.model';

export interface PromptVersion extends Entity {
  prompt_id: string;
  version: number;
  comment?: string;
  content: string;
  created_at?: string;
}

export class PromptVersionModel extends EntityModel<PromptVersion> {
  promptId: string;
  version: number;
  content: string;
  createdAt?: Date;

  constructor(src: PromptVersion) {
    super(src, 'prompt')
    this.promptId = src.prompt_id;
    this.version = src.version;
    this.content = src.content;
    this.createdAt = parseDate(src.created_at)
  }
}

export type CreatePromptVersion = Omit<CreateEntity<PromptVersion>, 'version' | 'prompt_id'>;
